module.exports = __webpack_public_path__ + "static/media/presentation.f0249813.jpg";